import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import api from '../services/api';

export default function LegalPage({ slug, title, subtitle }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPublicLayout(slug)
      .then(d => {
        if (d && !d.fallback && d.layout?.layout_json?.fields?.content) {
          setContent(d.layout.layout_json.fields.content);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px', fontFamily: "'Inter', sans-serif", color: 'var(--text-dark)', lineHeight: 1.75 }}>
      <Link to="/" style={{ color: 'var(--accent-saffron)', textDecoration: 'none', fontSize: '.88rem' }}>← Zurück zur Startseite</Link>
      <h1 style={{ fontFamily: "'Playfair Display', serif", marginTop: 32, marginBottom: 8 }}>{title}</h1>
      {subtitle && <p style={{ color: 'var(--text-mid)', fontSize: '.85rem', marginBottom: 40 }}>{subtitle}</p>}

      {loading ? (
        <div style={{ color: 'var(--text-mid)', fontSize: '.88rem' }}>Lade…</div>
      ) : content ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
      ) : (
        <div style={{ padding: '16px 20px', background: 'color-mix(in srgb, var(--accent-saffron) 12%, var(--surface))', borderRadius: 8, fontSize: '.85rem', color: 'var(--accent-saffron)', border: '1px solid color-mix(in srgb, var(--accent-saffron) 40%, transparent)', marginTop: 16 }}>
          ⚠️ Noch kein Inhalt — bitte im Admin unter Seiten → {title} → Inhalt bearbeiten.
        </div>
      )}
    </div>
  );
}
